(() => {
  const form = document.querySelector('#request-information');
  if (!form) return;
  const section = form.querySelector('[data-deposit-checkout]');
  const button = form.querySelector('[data-deposit-checkout]');
  const location = form.querySelector('[data-preferred-location]');
  const program = form.querySelector('#program-interest');
  const courses = {
    bench: { name: 'Bench Course', total: 1450, deposit: 725, variant: '47045450268860' },
    cita: { name: 'CITA ADEX Course', total: 2850, deposit: 1425, variant: '47045467373756' }
  };
  const modules = [
    { name: 'Bench - Restorative Module Online', total: 350, variant: '48461552681148' },
    { name: 'Bench - Prosthodontics Module Online', total: 450, variant: '48461553664188' },
    { name: 'CITA ADEX - Restorative Module Online', total: 500, variant: '48461554352316' },
    { name: 'CITA ADEX - Prosthodontics Module Online', total: 500, variant: '48461555597500' },
    { name: 'CITA ADEX - Endodontics Module Online', total: 500, variant: '48461556220092' },
    { name: 'CITA ADEX - Periodontics Module Online', total: 500, variant: '48461556744380' }
  ];
  const selected = () => program.dataset.moduleIndex !== undefined
    ? modules[Number(program.dataset.moduleIndex)]
    : (location.value === 'Live Online Seminar' ? null : (/CITA ADEX/.test(program.value) ? courses.cita : courses.bench));
  const online = () => location.value === 'Live Online Seminar' || program.dataset.moduleIndex !== undefined;
  const es = () => document.documentElement.lang === 'es';
  const money = n => '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2 });
  function refresh() {
    section.hidden = false;
    const c = selected();
    form.querySelector('[data-payment-terms]').hidden = false;
    button.href = '#request-information';
    button.textContent = online()
      ? (c ? (es() ? `Pagar ${money(c.total)} — Pago completo` : `Pay ${money(c.total)} — Full Payment`) : (es() ? 'Selecciona un módulo en línea' : 'Select an online module'))
      : (es() ? 'Pagar 50% de Depósito' : 'Pay 50% Deposit');
    form.querySelector('[data-payment-terms]').textContent = online()
      ? (es() ? 'Se requiere el pago completo para confirmar la inscripción al módulo en línea en vivo. Selecciona una de las próximas dos fechas. Nuestro equipo enviará los detalles de acceso.' : 'Full payment is required to confirm your live online module booking. Select one of the next two dates. Our team will send the access details.')
      : es()
      ? 'Tu cupo queda reservado después de completar el depósito del 50%. El balance restante se cobrará por separado 5 días antes del curso.'
      : 'Your seat is reserved after the 50% deposit is completed. The remaining balance will be collected separately 5 days before the course.';
  }
  location.addEventListener('change', refresh);
  document.addEventListener('adt-module-selected', refresh);
  document.addEventListener('adt-course-selected', refresh);
  document.addEventListener('click', event => {
    if (event.target.closest('[data-register-course], [data-register-link], [data-lang]')) refresh();
  });
  new MutationObserver(refresh).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  // Both forward actions share exactly the same registration checks.
  function validateRegistration() {
    for (const field of form.querySelectorAll('[required]')) {
      if (field.disabled) { field.setCustomValidity(''); continue; }
      field.setCustomValidity('');
      if (field.type === 'checkbox') {
        if (!field.checked) field.setCustomValidity(es()
          ? 'Debes aceptar esta declaración antes de continuar.'
          : 'Please acknowledge this statement before continuing.');
      } else if (!field.value.trim()) {
        field.setCustomValidity(es() ? 'Completa este campo antes de continuar.' : 'Please complete this field before continuing.');
      }
    }
    const phone = form.querySelector('[data-phone-field]');
    if (phone.value.replace(/\D/g, '').length !== 10) phone.setCustomValidity(es()
      ? 'Ingresa un teléfono de 10 dígitos.' : 'Please enter a 10-digit phone number.');
    return form.reportValidity();
  }
  for (const field of form.querySelectorAll('[required]')) {
    for (const type of ['input', 'change']) field.addEventListener(type, () => field.setCustomValidity(''));
  }
  function guard(event) {
    if (!validateRegistration()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  form.addEventListener('submit', guard);
  form.querySelector('[type="submit"]').addEventListener('click', guard);
  button.addEventListener('click', event => {
    event.preventDefault();
    if (!selected()) {
      document.querySelector('#live-seminars')?.scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (!validateRegistration()) return;
    const phone = form.querySelector('[data-phone-field]');
    const date = form.querySelector('[data-desired-date]');
    const c = selected();
    const url = new URL(`https://advancedentaltraining.com/cart/${c.variant}:1`);
    url.searchParams.set('checkout[email]', form.querySelector('[type="email"]').value.trim());
    url.searchParams.set('attributes[Participant name]', form.querySelector('[name="contact[name]"]').value.trim());
    url.searchParams.set('attributes[Participant phone]', phone.value.trim());
    url.searchParams.set('attributes[Course]', c.name);
    url.searchParams.set('attributes[Course location]', location.value);
    url.searchParams.set('attributes[Course date]', date.value);
    url.searchParams.set('attributes[Privacy Policy Acknowledgement]', 'Accepted');
    url.searchParams.set('attributes[Course Media Disclaimer Acknowledgement]', 'Accepted');
    url.searchParams.set('attributes[Registration notes]', form.querySelector('textarea').value);
    url.searchParams.set('locale', es() ? 'es' : 'en');
    window.location.assign(url.href);
  });
  refresh();
})();
